/**
 * @fileoverview Agent definition for world-species-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world species' details.
 * The user selects one direction before full details are generated.
 *
 * @category world-building.species.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-species-details-ideation-v3',
  kind: 'primitive',
  name: 'World Species Details Ideation',
  description: 'Generates creative directions for developing a world species before full detail generation.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.species.details',
    usedBy: ['use-world-species-details-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-species-details-generator-v3'],
  },
};
